import { S } from '@/shared/constants/styles';

function TagChip({ tag, active, onClick, isDark }) {
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        display: 'inline-flex', alignItems: 'center',
        background: active ? (isDark ? 'rgba(99,102,241,0.35)' : '#c7d2fe') : (isDark ? 'rgba(99,102,241,0.1)' : '#e0e7ff'),
        color: isDark ? '#a5b4fc' : '#3730a3',
        border: '1px solid ' + (isDark ? 'rgba(99,102,241,0.4)' : '#c7d2fe'),
        borderRadius: 6, padding: '3px 8px', fontSize: 11, fontWeight: active ? 700 : 500,
        cursor: 'pointer',
      }}
    >
      {tag}
    </button>
  );
}

export default function TransactionFilters({
  filterSearch, setFilterSearch,
  filterWho, setFilterWho,
  filterGroup, setFilterGroup,
  selectedTags, setSelectedTags,
  clearFilters, hasActiveFilters,
  resolvedMemberNames, allGroups,
  availableTags, isDark,
}) {
  const toggleTag = (tag) => {
    setSelectedTags(prev =>
      prev.includes(tag) ? prev.filter(t => t !== tag) : [...prev, tag]
    );
  };

  return (
    <div style={{ ...S.card, padding: 14, marginBottom: 16 }}>
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center' }}>
        <div style={{ flex: 1, minWidth: 160 }}>
          <input
            value={filterSearch}
            onChange={e => setFilterSearch(e.target.value)}
            placeholder="Search description or category..."
            style={{ ...S.input, fontSize: 12, padding: '7px 12px' }}
          />
        </div>
        <div style={{ minWidth: 100 }}>
          <select value={filterWho} onChange={e => setFilterWho(e.target.value)} style={{ ...S.select, fontSize: 12, padding: '7px 10px' }}>
            <option value="All">All members</option>
            {resolvedMemberNames.map(m => <option key={m} value={m}>{m}</option>)}
          </select>
        </div>
        <div style={{ minWidth: 120 }}>
          <select value={filterGroup} onChange={e => setFilterGroup(e.target.value)} style={{ ...S.select, fontSize: 12, padding: '7px 10px' }}>
            <option value="All">All categories</option>
            {allGroups.map(g => <option key={g} value={g}>{g}</option>)}
          </select>
        </div>
        {hasActiveFilters && (
          <button onClick={clearFilters} style={{ ...S.link('#ef4444'), fontSize: 11, whiteSpace: 'nowrap' }}>Clear filters</button>
        )}
      </div>
      {availableTags && availableTags.length > 0 && (
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginTop: 10, alignItems: 'center' }}>
          <span style={{ fontSize: 11, color: '#94a3b8', fontWeight: 600, whiteSpace: 'nowrap' }}>Tags:</span>
          {availableTags.map(tag => (
            <TagChip
              key={tag}
              tag={tag}
              active={selectedTags.includes(tag)}
              onClick={() => toggleTag(tag)}
              isDark={isDark}
            />
          ))}
        </div>
      )}
    </div>
  );
}
